// extracted by mini-css-extract-plugin
module.exports = {"input-layout":"customInput_input-layout__tiL8p","input":"customInput_input__d5L45","active":"customInput_active__Vb2F0","voice-layout":"customInput_voice-layout__oQWrd"};